<script>
import {
  DELETE_USER_GROUP,
  GET_USER_GROUP,
  GET_USER_GROUP_DETAIL,
} from '@/services/api/setting/user/userGroup'
import { mapGetters } from 'vuex'
import McButton from '@/components/McButton'
import McGrapqlTable from '@/components/McGrapqlTable'

export default {
  components: {
    McButton,
    McGrapqlTable,
  },

  data() {
    return {
      deleteUgroup: [],
      filterSelected: [],
      selectedIdsLength: 0,
      selectedIds: {},
      loading: false,
      customHandlers: {
        handleDisabledRow: (data) => {
          if (
            this.hasAccessAll([
              'tms-user-group:create',
              'tms-user-group:delete',
              'tms-user-group:read',
              'tms-user-group:update',
            ])
          ) {
            if (['Super Administrator', 'Super User Operational'].includes(data.name)) {
              return true
            }
          }
          return false
        },
      },
    }
  },
  computed: {
    groupSetting() {
      return [
        {
          key: 'name',
          label: this.$t('setting.list.userSetting.grupPengguna'),
          thClass: 'mc-table--50',
          sortable: false,
        },
        {
          key: 'vgroupTotal',
          label: this.$t('setting.list.userSetting.grupKendaraan'),
          thClass: 'mc-table--50',
          sortable: false,
        },
      ]
    },

    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),

    query() {
      return {
        get: async (filter) => {
          const adjustFilter = { ...filter }

          if (
            this.hasAccessAll([
              'tms-user-group:create',
              'tms-user-group:delete',
              'tms-user-group:read',
              'tms-user-group:update',
            ])
          ) {
            adjustFilter.showSuperUserOperational = true
          }

          const variables = {
            filter: {
              pagination: {
                page: adjustFilter?.pagination?.page,
                show: adjustFilter?.pagination?.show,
              },
              search: adjustFilter?.search,
              showSuperAdmin: true,
              showSuperUserOperational: adjustFilter?.showSuperUserOperational,
            },
          }

          const res = await this.$apollo.query({
            fetchPolicy: 'no-cache',
            query: GET_USER_GROUP,
            variables,
          })

          return res.data.ugroups.ugroups
        },
      }
    },
  },

  methods: {
    openModalDelete() {
      const deleteUgroup = []
      this.filterSelected = Object.keys(this.selectedIds).filter((item) => this.selectedIds[item])
      for (const iterator of this.filterSelected) {
        this.$apollo
          .query({
            query: GET_USER_GROUP_DETAIL,
            variables: {
              filter: {
                id: parseInt(iterator),
              },
            },
          })
          .then((res) => {
            let isSuccessful = res.data.ugroup.isSuccessful
            if (isSuccessful) {
              deleteUgroup.push(res.data.ugroup.ugroup)
            }
          })
      }

      this.deleteUgroup = deleteUgroup
      this.$bvModal.show('modal-delete-group')
    },

    toDelete(bvModalEvent) {
      bvModalEvent.preventDefault()
      let promises = []
      for (const iterator of this.filterSelected) {
        promises.push(
          this.$apollo.mutate({
            mutation: DELETE_USER_GROUP,
            variables: {
              input: {
                id: Number(iterator),
              },
            },
          })
        )
      }

      Promise.all(promises)
        .then((data) => {
          let self = this
          self.loading = true
          data.forEach(function (item) {
            if (item.data !== undefined && !item.data.deleteUgroup.isSuccessful) {
              self.$mcToast.warning(item.data.deleteUgroup.message)
            } else {
              self.$mcToast.success(self.$t('global.alert.text.delete'))
            }
          })
          self.$bvModal.hide('modal-delete-group')
        })
        .catch((e) => {
          console.log(e)
        })

      setTimeout(() => {
        this.loading = false
      }, 200)
    },

    resetModal() {
      this.deleteUgroup = []
    },

    onRowClicked(item) {
      if (
        !this.hasAccessAll([
          'c1a-default-setpengguna:read',
          'ugroups:update',
          'mgroups:read',
          'vgroups:read',
        ])
      ) {
        return
      }
      this.$router.push({
        name: 'Update Setting Group User',
        params: { id: item.id },
      })
    },
  },
}
</script>

<template>
  <div>
    <McGrapqlTable
      v-if="!loading"
      :fields="groupSetting"
      :customHandlers="customHandlers"
      :searchable="true"
      :hasSelectAll="true"
      :showPagination="true"
      :withCard="false"
      trackBy="id"
      :apiClient="query"
      :hasDelete="false"
      :customButton="true"
      :hasDisabled="true"
      @totalSelected="(value) => (selectedIdsLength = value)"
      @handleSelectValue="(value) => (selectedIds = value)"
    >
      <template #button-header>
        <McButton
          v-if="
            selectedIdsLength &&
            hasAccessAll([
              'c1a-default-setpengguna:read',
              'ugroups:delete',
              'mgroups:read',
              'vgroups:read',
            ])
          "
          :text="$t('global.delete')"
          class="mx-2"
          icon="icon-outline_trash"
          variant="secondary-red"
          @click="openModalDelete"
        />
        <McButton
          v-if="
            hasAccessAll([
              'c1a-default-setpengguna:read',
              'ugroups:create',
              'mgroups:read',
              'vgroups:read',
            ])
          "
          :text="$t('global.addField')"
          icon="icon-outline_plus"
          variant="primary"
          @click="$router.push({ name: 'Create Setting Group User' })"
        />
      </template>

      <template #cell(name)="data">
        <strong
          class="fw-bold text-primary td__noellipsis clickable-field"
          @click="onRowClicked(data.item)"
        >
          {{ data.item.name }}
        </strong>
      </template>

      <template #cell(vgroupTotal)="data">
        <span v-if="data.item.vgroups.length == 0"> Semua Grup Kendaraan </span>
        <span v-else>
          {{ data.item.vgroups.length }}
        </span>
      </template>
    </McGrapqlTable>

    <b-modal
      id="modal-delete-group"
      class="mc-modal"
      :title="$t('global.delete')"
      size="md"
      centered
      scrollable
      @hidden="resetModal"
    >
      <div class="card-body mc-modal__filter p-2">
        <p>{{ $t('global.confirmDelete1') }} {{ $t('global.confirmDelete2') }}</p>
        <b-list-group>
          <b-list-group-item v-for="ugroup in deleteUgroup" :key="ugroup.id">
            {{ ugroup.name }}
          </b-list-group-item>
        </b-list-group>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
            <McButton
              variant="secondary"
              class="me-2"
              :text="$t('global.action.no')"
              @click="cancel()"
            />
            <McButton variant="primary" :text="$t('global.action.yes')" @click="toDelete" />
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </div>
</template>
